import { lazy } from "react";
import { Route } from "react-router-dom";
import { FlexRoot } from "../../components/flexible/FlexRoot";
import { UploadType } from "../../models/upload-type";

const CaseSelection = lazy(() => import("../../containers/data/forms/CaseSelection"));
const DataHome = lazy(() => import("../../containers/data/DataHome"));
const DataSourceFormUpload = lazy(() => import("../../containers/data/uploads/Overview"));

export const local52Routes = () => [
	{
		key: "5.2.7",
		link: "/data/entity-params-selection/:formTypeId",
		component: (props: any) => <CaseSelection {...props} formTypeId={props.match.params.formTypeId} />,
	},
	{
		key: "5.2.0.1",
		link: "/data/forms/:entityId",
		component: (props: any) => <FlexRoot {...props} entityId={props.match.params.entityId} isExistingForm={true} />,
	},
	{
		key: "5.2.0.1",
		link: "/data/forms/new/:typeId",
		component: (props: any) => <FlexRoot {...props} typeId={props.match.params.typeId} />,
	},
	{
		key: "5.2.8",
		link: "/data/forms/upload/:typeId",
		component: (props: any) => (
			<DataSourceFormUpload {...props} uploadType={UploadType.Forms} uploadTypeId={props.match.params.typeId} />
		),
	},
];

export default function Key52Routes(key: string, link: string) {
	const key52Routes = [{ key: key, link: link, component: (props: any) => <DataHome {...props} /> }, ...local52Routes()];

	return key52Routes.map((r) => <Route exact key={r.key} path={r.link} render={r.component} />);
}
